import { getStoredFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { SemboUser } from './members.interfaces';

const stored = getStoredFakeData();

function getFakeSemboUser(): SemboUser | null {
    return {
        member: {
            birthDate: null,
            city: null,
            countryCode: null,
            email: 'johndoe@sembo.se',
            firstName: 'John',
            internalUser: false,
            lastName: 'Doe',
            postalCode: null,
            streetAddress: null,
            travelAgencyId: null,
            userName: 'johndoe@sembo.se',
            userNameHash: '12345678',
            ...stored?.auth?.member,
        },
        memberOptions: { countries: [] },
    };
}

export const fakeMember = getFakeSemboUser();
